import { request } from 'graphql-request';
import { API_URL } from 'appenv';
import { GraphQLVideoCallParticipantAcceptInput, GraphQLVideoCallParticipantAcceptPayload } from './graphql-models';

const videoCallInvitationAcceptMutation = `
mutation VideoCallParticipantAccept($participantId: String!, $roomToken: String!) {
  videoCallParticipantAccept(input: {
    participantId: $participantId,
    roomToken: $roomToken
  }) {
    success
    errors {
      message
      type
      path
    }
  }
}

`;

const AcceptVideoCallInvitation = (participantId: string, roomToken: string): Promise<GraphQLVideoCallParticipantAcceptPayload> => request(
  API_URL,
  videoCallInvitationAcceptMutation,
  {
    participantId,
    roomToken,
  } as GraphQLVideoCallParticipantAcceptInput,
).then(({ videoCallParticipantAccept }) => videoCallParticipantAccept);

export default AcceptVideoCallInvitation;
